module.exports = __webpack_public_path__ + "static/media/AMITH KRISHNA A.7535eea6.jpg";